import { useEffect, useState } from 'react'
import { validateAuthToken, acceptInvite } from '../services/api'

export default function AcceptInvite() {
  const params = new URLSearchParams(window.location.search)
  const token = params.get('token') ?? ''
  const [state, setState] = useState<'checking' | 'ok' | 'invalid' | 'done'>('checking')
  const [email, setEmail] = useState<string | null>(null)
  const [pw, setPw] = useState('')
  const [pw2, setPw2] = useState('')
  const [err, setErr] = useState<string | null>(null)

  useEffect(() => {
    if (!token) { setState('invalid'); return }
    validateAuthToken(token)
      .then((r) => { setEmail(r.data.email); setState(r.data.valid ? 'ok' : 'invalid') })
      .catch(() => setState('invalid'))
  }, [token])

  const submit = async () => {
    setErr(null)
    if (pw.length < 8) { setErr('Password must be at least 8 characters'); return }
    if (pw !== pw2) { setErr('Passwords do not match'); return }
    try {
      await acceptInvite(token, pw)
      setState('done')
    } catch (e: any) {
      setErr(e?.response?.data?.detail ?? 'Could not set password')
    }
  }

  return (
    <div className="min-h-screen flex items-center justify-center bg-gray-100">
      <div className="bg-white rounded-lg shadow-sm border border-gray-200 p-8 w-full max-w-md">
        <h1 className="text-xl font-bold text-gray-900 mb-4">Tarana Control</h1>
        {state === 'checking' && <p className="text-gray-500">Checking your link…</p>}
        {state === 'invalid' && (
          <p className="text-red-600">This link is invalid or has expired. Ask an admin to resend it.</p>
        )}
        {state === 'done' && (
          <div>
            <p className="text-green-700 mb-3">Password set. You can sign in now.</p>
            <a href="/login" className="text-primary-600 hover:underline">Go to login →</a>
          </div>
        )}
        {state === 'ok' && (
          <div className="space-y-3">
            <p className="text-sm text-gray-600">Set a password for <strong>{email}</strong>.</p>
            <input type="password" placeholder="New password" value={pw}
              onChange={(e) => setPw(e.target.value)}
              className="w-full px-3 py-2 border border-gray-300 rounded-md" />
            <input type="password" placeholder="Confirm password" value={pw2}
              onChange={(e) => setPw2(e.target.value)}
              className="w-full px-3 py-2 border border-gray-300 rounded-md" />
            {err && <p className="text-sm text-red-600">{err}</p>}
            <button onClick={submit}
              className="w-full px-4 py-2 bg-primary-600 text-white rounded-md hover:bg-primary-700">
              Set password
            </button>
          </div>
        )}
      </div>
    </div>
  )
}
